import { apiRoutes } from "../Constant/ApiRoutes";
import {
  getRequest,
  postRequest,
  deleteRequest,
} from "../apiRequest";

export const getDomainDetails = () => {
  return getRequest(apiRoutes.kbGetCustomDomainDetails);
};

export const initiateCustomDomain = (domainName) => {
  return postRequest(apiRoutes.KbCustomDomainInitiate, "", {
    customDomain: domainName,
  });
};

export const configureCustomDomain = () => {
  return postRequest(apiRoutes.KbCustomDomainConfigure);
};

export const deleteCustomDomain = () => {
  return deleteRequest(apiRoutes.KbCustomDomainRemove);
};
